/**
 * Тексты FAQ. Менять вопросы/ответы здесь, не в разметке.
 */

export const FAQ_COPY = {
    badgeText: "Client Satisfaction",
    maintenanceTitle: "Maintenance Question",
    maintenanceDescription: "Common questions about ongoing support, updates, and technical assistance after your project goes live",
    label: "FAQ's",
    title: "General Question",
    description: "Got questions? Find quick answers below or reach out to discuss your specific project needs.",
};

export const MAINTENANCE_ITEMS = [
    {
        question: "Do You Provide Post-Launch Support?",
        answer: "Yes, we offer flexible maintenance packages including bug fixes, feature updates, performance monitoring, and 24/7 emergency support. Support terms are discussed individually based on project complexity.",
    },
    {
        question: "How Quickly Do You Fix Critical Bugs?",
        answer: "Critical bugs are prioritized and fixed within 24 hours. We provide emergency hotline for urgent issues.",
    },
    {
        question: "Can You Add New Features After Launch?",
        answer: "Yes, we can add new features at any time. We analyze requirements and provide estimates for implementation.",
    },
    {
        question: "What If My Developer Left And I Need Help?",
        answer: "We can take over any project. We audit the code, document it, and continue development seamlessly.",
    },
    {
        question: "Do You Offer Server Management?",
        answer: "Yes, we provide complete server management including setup, monitoring, backups, and optimization.",
    },
];

export const FAQ_ITEMS = [
    {
        question: "How Long Does Development Take?",
        answer: "Project timelines vary based on complexity. Simple bots take 3-7 days, web applications 2-4 weeks, and complex enterprise systems 2-3 months. We provide detailed timeline estimates after analyzing your requirements.",
    },
    {
        question: "What Technologies Do You Use?",
        answer: "We work with React, Node.js, Python, TypeScript, and modern frameworks. Our tech stack is chosen based on project requirements to ensure optimal performance and maintainability.",
    },
    {
        question: "Do You Provide Support After Launch?",
        answer: "Yes, we offer ongoing maintenance and support packages. This includes bug fixes, updates, and feature enhancements to keep your project running smoothly.",
    },
    {
        question: "How Much Does a Project Cost?",
        answer: "Pricing depends on project scope and complexity. Simple bots start from $500, web applications from $2000. Contact us for a detailed quote tailored to your needs.",
    },
    {
        question: "Can You Work With Existing Code?",
        answer: "Absolutely! We can audit, refactor, and extend existing codebases. Whether you need bug fixes, new features, or complete modernization, we've got you covered.",
    },
];

// config/faq.js
